export function initAnchorScroll(offset = 80) {
    function scrollToHash(hash, smooth = true) {
        if (!hash || hash === '#') return;

        const target = document.querySelector(hash);
        if (!target) return;

        const y = target.getBoundingClientRect().top + window.pageYOffset - offset;

        window.scrollTo({
            top: y,
            behavior: smooth ? 'smooth' : 'auto'
        });
    }

    // Same-page anchor clicks
    const links = document.querySelectorAll('a[href*="#"]');

    links.forEach((link) => {
        link.addEventListener('click', function (e) {
            const url = new URL(this.href, window.location.origin);

            // Only intercept if it's the current page
            const isSamePage = url.pathname === window.location.pathname && url.origin === window.location.origin;

            if (!isSamePage || !url.hash || url.hash === '#') return;

            const target = document.querySelector(url.hash);
            if (!target) return;

            e.preventDefault();
            history.pushState(null, '', url.hash);
            scrollToHash(url.hash, true);
        });
    });

    // Cross-page load with hash
    window.addEventListener('load', () => {
        if (!window.location.hash) return;

        // small delay helps if images / fonts / scripts shift layout
        setTimeout(() => {
            scrollToHash(window.location.hash, false);
        }, 150);
    });
}
